__turbopack_context__.v({
  "teaser-box__button-external": "WqOeXq_teaser-box__button-external",
});
